export default {
  multiCall: {
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    97: '0x8F3273Fb89B075b1645095ABaC6ed17B2d4Bc576',
    80001: '0xe9939e7Ea7D7fb619Ac57f648Da7B1D425832631',
  },
  predictions: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '0xBcA68413F399A184D453b2Bc5b3d3c55a1659558',
    80001: '0xBD2e11702ABd48d9936A157c919B76e53a55F6A6',
  },
  chainlinkOracle: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
    80001: '0xB8ce593E3C94Ad25Bc87D7e3e484C98A4A82335E',
  },
  raffle: {
    56: '',
    97: '',
    80001: '0x2dce8f6CE41Da154275E437D6F0c3B228A740444',
  },
}
